// extracted by css-extract-rspack-plugin
export default {"body":"body-CK68X_","linkField":"linkField-er_mg8","linkAction":"linkAction-nD6B2G","copyBtn":"copyBtn-i2QqqQ","copiedIcon":"copiedIcon-Wc5LOc","previewLink":"previewLink-pUanxF"};